import { render } from "./ShuaituMorPPage.vue?vue&type=template&id=d2b4fbaa&scoped=true"
import script from "./ShuaituMorPPage.vue?vue&type=script&lang=js"
export * from "./ShuaituMorPPage.vue?vue&type=script&lang=js"

import "./ShuaituMorPPage.vue?vue&type=style&index=0&id=d2b4fbaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b4fbaa"]])

export default __exports__